import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router' // 新增：路由（用于401跳转登录）

// 创建 axios 实例
const service = axios.create({
  baseURL: '',
  timeout: 10000 // 超时时间10秒
})

// ==================== 请求拦截器 ====================
// 发送请求前执行：统一添加 token
service.interceptors.request.use(
  config => {
    // 从本地存储获取 token
    const token = localStorage.getItem('token')
    if (token) {
      // 后端通常要求格式：Bearer + token
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    // 请求出错（如断网）
    return Promise.reject(error)
  }
)

// ==================== 响应拦截器 ====================
// 接口返回后执行：统一处理成功/失败/登录过期
service.interceptors.response.use(
  response => {
    const res = response.data

    // 后端自定义成功码：一般是 200 / 0
    if (res.code !== 200 && res.code != null && res.code != '') {
      // 业务状态码 401：未登录，跳转登录页
      if (res.code == 401) {
        Message.error('您未登录，请先登录')
        localStorage.removeItem('token')
        router.replace('/login')
        return Promise.reject(res)
      }
      Message.error(res.msg || '请求失败')
      return Promise.reject(res)
    }

    // 成功：直接返回数据
    return res
  },
  error => {
    // HTTP 状态码错误处理（4xx/5xx）
    if (error.response) {
      const { status } = error.response

      // 401：token 过期/未登录 → 跳转到登录页
      if (status == 401) {
        Message.error('登录已过期，请重新登录')
        localStorage.removeItem('token') // 清除失效token
        router.replace('/login') // 跳登录
      }
      // 其他状态码
      else {
        Message.error(error.response.data.message || '请求异常')
      }
    } else {
      // 无响应：网络问题
      Message.error('网络异常，请稍后重试')
    }

    return Promise.reject(error)
  }
)

export default service